import React, { useContext } from 'react';
import BlockIcon from '@mui/icons-material/Block';
import { useTranslation } from 'react-i18next';
import AuthContext from '../../../contexts/auth-context';
import { MasterHeader } from '../../layouts/components/MasterHeader/MasterHeader';
import { MHCRoles } from '../../../providers/permissions/mhc-roles';
const AccessDenied = () => {
    const { t } = useTranslation();
    const { authContextData, mhcRoles } = useContext(AuthContext);
    const allowedRoles = Object.values(MHCRoles);
    const hasNoAdminPortalRoles =
        !!authContextData?.currentUser &&
        mhcRoles !== undefined &&
        !mhcRoles.some((role) => allowedRoles.includes(role));
    return (
        <div className='h-screen w-screen flex flex-col'>
            {authContextData?.currentUser && <MasterHeader />}
            <div className="flex flex-col items-center justify-center h-[439px] w-[811px] py-auto px-10 mx-auto mt-[24vh] rounded-lg bg-gray-100">
                <BlockIcon className="text-red-600 mb-4" sx={{ fontSize: 62 }} />
                <h1 className=" font-bold text-3xl mb-2">{t("labels.access-denied")}</h1>
                <p className="mt-4 text-xl text-gray-700">
                    {hasNoAdminPortalRoles
                        ? t("labels.no-admin-portal-roles-message")
                        : t("labels.access-denied-message")}
                </p>

            </div>
        </div>
    );
};

export default AccessDenied;